import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Gift, Clock } from 'lucide-react';
const bonuses = [{
  number: 1,
  title: 'Sustratos Caseros',
  description: 'Preparación y uso correcto, errores frecuentes, reutilización y mantenimiento',
  image: 'https://cdn.magicpatterns.com/uploads/wR8F9Fgc743Cnv9nXS56Co/Preparacion_Y_Uso_Correcto,_Errores_Frecuentes,_Reutilizacion_Y_Mantenimiento,_-_1_-_Editado.png'
}, {
  number: 2,
  title: 'Guía Rápida de Plantas Populares',
  description: 'Las plantas más fáciles de propagar con instrucciones específicas para cada una',
  image: 'https://cdn.magicpatterns.com/uploads/gSvLaPnJ2MBwPirUfByLfx/ChatGPT_Image_15_dic_2025,_14_45_11.png'
}, {
  number: 3,
  title: 'Hormonas de Enraizamiento Caseras',
  description: 'Cómo preparar tus propias hormonas naturales para acelerar el enraizamiento',
  image: 'https://cdn.magicpatterns.com/uploads/oxqn88xki5JgyucisDt5hh/Diseno_Sin_Titulo_-_1_-_Editado_(1).png'
}, {
  number: 4,
  title: 'Mini Invernadero Casero',
  description: 'Construye tu propio mini invernadero con materiales que ya tienes en casa',
  image: 'https://cdn.magicpatterns.com/uploads/9pZDhSkpttFShT8mC7fhPa/Diseno_Sin_Titulo_-_1_-_Editado.png'
}, {
  number: 5,
  title: 'Calendario del Esqueje',
  description: 'Sabe exactamente cuándo es el mejor momento para hacer esquejes de cada planta',
  image: 'https://cdn.magicpatterns.com/uploads/uc2mFUHECxPwEveFFuHsuH/ChatGPT_Image_15_dic_2025,_14_41_41_-_Editado.png'
}];
function getInitialTime(): number {
  if (typeof window === 'undefined') return 30 * 60;
  const stored = localStorage.getItem('bonus_timer_start');
  if (stored) {
    const elapsed = Math.floor((Date.now() - parseInt(stored)) / 1000);
    const remaining = 30 * 60 - elapsed;
    return remaining > 0 ? remaining : 0;
  }
  localStorage.setItem('bonus_timer_start', Date.now().toString());
  return 30 * 60;
}
export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(getInitialTime);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return {
    minutes,
    seconds,
    timeLeft,
    isExpired: timeLeft <= 0
  };
}
export function BonusSection() {
  return <section className="py-20 bg-white" data-id="element-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="max-w-5xl mx-auto" data-id="element-14">
          {/* Header */}
          <div className="text-center mb-14" data-id="element-15">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-100 text-orange-700 text-sm font-bold mb-6 border border-orange-200" data-id="element-16">
              <Gift className="w-4 h-4" data-id="element-17" />
              Incluidos con tu compra
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-18">
              5 Bonus que aceleran tus resultados
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-19">
              Además de la guía principal, recibes estos materiales extra sin
              costo adicional
            </p>
          </div>

          {/* Bonus List */}
          <div className="space-y-8" data-id="element-20">
            {bonuses.map((bonus, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className={`flex flex-col sm:flex-row items-center gap-6 sm:gap-8 p-6 rounded-2xl border border-gray-100 bg-[#fafaf9] ${i % 2 !== 0 ? 'sm:flex-row-reverse' : ''}`} data-id="element-21">
                {/* Image */}
                <div className="w-40 sm:w-48 flex-shrink-0" data-id="element-22">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-auto rounded-lg shadow-lg" data-id="element-23" />
                </div>

                {/* Content */}
                <div className={`flex-1 text-center sm:text-left ${i % 2 !== 0 ? 'sm:text-right' : ''}`} data-id="element-24">
                  <span className="inline-block text-xs font-bold text-white bg-[#4a7c2c] px-3 py-1 rounded-full mb-3" data-id="element-25">
                    BONUS {bonus.number}
                  </span>
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-26">
                    {bonus.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-27">{bonus.description}</p>
                </div>
              </motion.div>)}
          </div>

          {/* Bottom note */}
          <div className="text-center mt-12" data-id="element-28">
            <p className="text-sm font-medium text-[#4a7c2c] bg-[#4a7c2c]/5 inline-block px-6 py-3 rounded-full border border-[#4a7c2c]/10" data-id="element-29">
              🎁 Todos los bonus se entregan junto con la guía, en formato PDF,
              con acceso inmediato
            </p>
          </div>
        </div>
      </div>
    </section>;
}